import { GET_BOUNCER_DATA } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const Get_Bouncer_Data = (payload) => {
    return apiInstance.post(GET_BOUNCER_DATA, payload);
  };
  